module.exports = __webpack_public_path__ + "static/img/gengxin.99cfad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/gengxin.png
// module id = cPZ0
// module chunks = 24